export type QuizKey = 'CorrectAnswer' | 'CorrectAnswers' | 'NumberOfQuestions' | 'WrongAnswer' | 'YouHaveCompletedQuizAndReceived';

interface DictionaryFunctions {
	get(key: QuizKey): string;
}

export const QuizItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: QuizKey): string => {
			switch (key) {
				case 'CorrectAnswers':
					return getValue('Quiz.CorrectAnswers', 'Rigtige svar');
				case 'CorrectAnswer':
					return getValue('Quiz.CorrectAnswer', 'Svaret er rigtigt');
				case 'NumberOfQuestions':
					return getValue('Quiz.NumberOfQuestions', 'Antal spørgsmål');
				case 'WrongAnswer':
					return getValue('Quiz.WrongAnswer', 'Svaret er forkert');
				case 'YouHaveCompletedQuizAndReceived':
					return getValue('Quiz.YouHaveCompletedQuizAndReceived', 'Du har nu gennemgået quizzen og fik');
			}
		},
	};
};
